import ABSService from "./absService";

class AppService extends ABSService {
    constructor() {
        super("app");
    }

    getList = async (query) => this.requestHelper.get(this.URL, query, { showMask: false });

    getAdminGroups = async () => this.requestHelper.get("/api/admin/app-groups", null, { showMask: false });

    create = async (data) => this.requestHelper.put(this.URL, data, { showMask: false });

    update = async (data) => this.requestHelper.post(this.URL, data, { showMask: false });

    delete = async (id) => this.requestHelper.delete(`${this.URL}/${id}`, { showMask: false });
}

export default AppService;
